module.exports = "<canvas #myCanvas></canvas>"